import React, { PureComponent } from 'react';

import { Card } from '@philips-emr/tws-components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { MessageService } from '@philips-emr/tws-core/lib/services';
import { format } from '@philips-emr/tws-core/lib/services/model-service';
import { trigger } from '@philips-emr/tws-utils';

import HpmsContextMenuBeneficiaryChange from './hpms-context-menu-beneficiary-change'

import './hpms-beneficiary-change.scss';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
class HpmsBeneficiaryChangeCard extends PureComponent {

  static propTypes = {
    onClick: eventListener,
    ieSituacao: string,
    dsTitularidade: string,
    nmPessoaFisica: string,
    cdUsuarioPlano: string,
    dtRescisao: string,
    nmTitular: string,
    dtCriacao: string,
    nrSeqSegurado: string,
    cdPessoaFisica: string,
    nrSeqBeneficiario: string,
  }

  state = {
    data: [],
  }

  renderHeader() {
    const { dsTitularidade, nrSeqSegurado, cdPessoaFisica } = this.props;

    return (
      <div className="c-hpms-requisicao-autorizacao-card__header">
        <div className="c-hpms-requisicao-autorizacao-card__header-left">
          <div className="c-label">{MessageService.translate('stipulator.titularidade')}</div>
          <div className="c-hpms-requisicao-autorizacao-card__header-left-content">{dsTitularidade}
          </div>
        </div>
        <div className="c-hpms-requisicao-autorizacao-card__header-rigth">
          <div className="c-hpms-requisicao-autorizacao-card__header-rigth-context-menu">
            <HpmsContextMenuBeneficiaryChange cdPessoaFisica={cdPessoaFisica} nrSeqBeneficiario={nrSeqSegurado} >
            </HpmsContextMenuBeneficiaryChange>
          </div>
        </div>
      </div>
    )
  }

  renderContent() {
    const { nmPessoaFisica, cdUsuarioPlano, dtRescisao } = this.props;

    return (
      <div className=".c-hpms-requisicao-autorizacao-card__body-left">
        <div className="c-label">{MessageService.translate('stipulator.beneficiario')}</div>
        <div className="c-beneficiary-change-card__content_bold">{nmPessoaFisica}</div>
        <div className="c-label">{MessageService.translate('stipulator.carteira')}</div>
        <div className="c-beneficiary-change-card__content">{cdUsuarioPlano}</div>
        {dtRescisao &&
          <div>
            <div className="c-label">{MessageService.translate('stipulator.data-rescisao')}</div>
            <div className="c-beneficiary-change-card_npm_content">{format('date', dtRescisao)}</div>
          </div>
        }
      </div>
    );
  }

  getColor() {
    const { ieSituacao } = this.props;

    switch (ieSituacao) {
      case 'A':
        return 'green';
      case 'D':
        return 'blue';
      case 'M':
        return 'yellow';
      case 'I':
        return 'red';
    }
  }

  render() {
    const { onClick } = this.props;

    return (
      <Card width="12" className="c-beneficiary-change-card" onClick={trigger(onClick)}>
        <div className={`c-beneficiary-change-card__wrapper c-beneficiary-change-card__border-${this.getColor()}`}>
          {this.renderHeader()}
          {this.renderContent()}
        </div>
      </Card>
    );
  }
}

export default HpmsBeneficiaryChangeCard;
